export { default } from './ProductReviewSummaryRangeSlider'
